import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import { Add } from '@material-ui/icons'
import { useMutation } from '@apollo/client'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { MC_VEHICLE_MAKE } from 'graphql/mutations'
import styles from '../vehicle.module.scss'

const NewMake = ({ loading, update, modelId }) => {
  const [mkUi, setMkUI] = useState(false)
  const [make, setMake] = useState()
  const [makeList, setMakeList] = useState([])
  const [vvrName, setVvrName] = useState('')
  const [sdmzFile, setSdmzFile] = useState()

  const [call] = useMutation(MC_VEHICLE_MAKE)

  const handleClose = () => {
    setMkUI(false)
  }
  const submit = () => {
    handleClose()
    loading(true)
    call({
      variables: {
        modelId: parseInt(modelId),
        modelYear: parseInt(make),
        vvrBdyColor: [],
        vvrIntColor: [],
        sdmzFile,
        vvrName,
      },
    })
      .then(res => {
        update()
      })
      .catch(err =>
        console.log(err, {
          modelId: parseInt(modelId),
          modelYear: make,
          sdmzFile,
          vvrName,
        })
      )
  }

  useEffect(() => {
    const d = new Date()
    const currentYear = d.getFullYear()
    let yearList = []
    for (let y = 1960; y <= currentYear + 4; y++) {
      yearList.push(y)
    }
    setMakeList(yearList)
    setMake(yearList[yearList.length - 5])
  }, [])

  return (
    <div>
      <div>
        <Button
          endIcon={<Add />}
          variant="contained"
          fullWidth={false}
          color="primary"
          className={styles.addNewVariationButton}
          onClick={() => setMkUI(true)}
        >
          add new make{' '}
        </Button>
      </div>
      <Dialog open={mkUi} onClose={() => setMkUI(false)}>
        <DialogTitle>Create new Make</DialogTitle>
        <DialogContent dividers className={styles.makeDialogContent}>
          <Select
            label="Make"
            value={make}
            onChange={m => setMake(m.target.value)}
          >
            {makeList.map((m, i) => (
              <MenuItem key={i} value={m}>
                {m}
              </MenuItem>
            ))}
          </Select>
          <TextField
            value={vvrName || ''}
            onChange={v => setVvrName(v.target.value)}
            label="varint name"
            variant="outlined"
            className={styles.variantName}
          />
          <Button
            autoFocus
            margin="dense"
            id="model"
            label="Model"
            type="file"
            variant="contained"
            component="label"
          >
            upload Model
            <input
              type="file"
              onChange={e => {
                setSdmzFile(e.target.files.item(0))
              }}
              accept=".sdmz"
            />
          </Button>

          <DialogActions>
            <Button
              variant="contained"
              onClick={() => submit()}
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default NewMake
